export const AllProvincesArray = [
    {
        text: "آذربایجان شرقی",
        value: "AE",
    },
    {
        text: "آذربایجان غربی",
        value: "AW",
    },
    {
        text: "اردبیل",
        value: "AR",
    },
    {
        text: "اصفهان",
        value: "IS",
    },
    {
        text: "البرز",
        value: "AL",
    },
    {
        text: "ایلام",
        value: "IL",
    },
    {
        text: "بوشهر",
        value: "BU",
    },
    {
        text: "تهران",
        value: "TE",
    },
    {
        text: "چهارمحال و بختیاری",
        value: "CM",
    },
    {
        text: "خراسان جنوبی",
        value: "KJ",
    },
    {
        text: "خراسان رضوی",
        value: "KV",
    },
    {
        text: "خراسان شمالی",
        value: "KS",
    },
    {
        text: "خوزستان",
        value: "KZ",
    },
    {
        text: "زنجان",
        value: "ZA",
    },
    {
        text: "سمنان",
        value: "SM",
    },
    {
        text: "سیستان و بلوچستان",
        value: "SB",
    },
    {
        text: "فارس",
        value: "FA",
    },
    {
        text: "قزوین",
        value: "QZ",
    },
    {
        text: "قم",
        value: "QM",
    },
    {
        text: "کردستان",
        value: "KD",
    },
    {
        text: "کرمان",
        value: "KE",
    },
    {
        text: "کرمانشاه",
        value: "BK",
    },
    {
        text: "کهگیلویه و بویراحمد",
        value: "KB",
    },
    {
        text: "گلستان",
        value: "GO",
    },
    {
        text: "گیلان",
        value: "GI",
    },
    {
        text: "لرستان",
        value: "LO",
    },
    {
        text: "مازندران",
        value: "MN",
    },
    {
        text: "مرکزی",
        value: "MK",
    },
    {
        text: "هرمزگان",
        value: "HG",
    },
    {
        text: "همدان",
        value: "HD",
    },
    {
        text: "یزد",
        value: "YA",
    },
];